import {get} from "lodash"
import {isWorkCentreEnabled, WorkCentreStatus} from "helpers/production"

export const getDepartmentsForType = (state, departmentType) => {
  const departments = state.departmentContext.departments || []
  return departments.filter(department => {
    const actualDepartmentType = get(department, 'departmentType', departmentType)
    return actualDepartmentType === departmentType
  })
}

export const getWorkCentresForType = (state, departmentType) => {
  const workCentres = state.departmentContext.workCentres || []
  return workCentres.filter(workCentre => {
    const workCentreStatus = get(workCentre, 'workCentreStatus', WorkCentreStatus.ENABLED)
    const actualDepartmentType = get(workCentre, 'departmentType', departmentType)
    return isWorkCentreEnabled(workCentreStatus)
      && actualDepartmentType === departmentType
  })
}